var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M52.026,38.947a5.65,5.65,0,0,0-3.975-4C44.544,34,30.483,34,30.483,34s-14.061,0-17.568.946a5.65,5.65,0,0,0-3.975,4C8,42.476,8,49.84,8,49.84s0,7.364.94,10.893a5.65,5.65,0,0,0,3.975,4c3.507.946,17.568.946,17.568.946s14.061,0,17.568-.946a5.65,5.65,0,0,0,3.975-4c.94-3.529.94-10.893.94-10.893S52.966,42.476,52.026,38.947ZM25.884,56.526V43.154L37.636,49.84Z","transform":"translate(-8 -34)","fill":"#ebebed"}));
}

Youtube.defaultProps = {"focusable":"false","width":"44.966","height":"31.68","viewBox":"0 0 44.966 31.68"};

module.exports = Youtube;

Youtube.default = Youtube;
